import { render, staticRenderFns } from "./ExtraBonusIntersectionObserver.vue?vue&type=template&id=564c270a"
import script from "./ExtraBonusIntersectionObserver.vue?vue&type=script&lang=js"
export * from "./ExtraBonusIntersectionObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports